import { useParams } from 'react-router-dom'

import { Features } from 'generated/featureDefinitions'
import { RequestOrPromotePageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import PromoteFlow from 'modules/contracts/components/PromoteFlow'
import RequestPromoteFlow from 'modules/contracts/components/RequestPromoteFlow'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const RequestOrPromote = () => {
  const { id: employeeId } = useParams()
  const { company, access } = useCurrentSession()
  const { data, loading } = useQuery(RequestOrPromotePageDocument, {
    variables: {
      companyId: company.id,
      employeeId: String(employeeId),
    },
    skip: !employeeId,
  })

  const isAutoApprover = data?.approvals?.approvalGroupMembershipsConnection?.nodes?.some(
    (membership) => membership?.access?.id === access.id
  )
  const hasToRequestPromotion = !isAutoApprover
  const referenceContract = data?.contracts.referenceContractsConnection.nodes[0]
  const canPromote = referenceContract?._policies?.promote.can ?? false
  const canEdit = referenceContract?._policies?.edit.can ?? false
  const canAccessFlowsPage = canPromote || canEdit
  const hasLegacyJobCatalog =
    data?.features?.featuresConnection?.nodes?.find(
      (feature) => feature.name === 'legacy_job_catalog'
    )?.enabled ?? false
  const jobCatalogTreeFeatureEnabled = !hasLegacyJobCatalog
  const jobCatalogTrees = data?.jobCatalog?.treesConnection?.nodes
  const hasPayrollBundle =
    data?.companies.featureAvailabilitiesConnection.nodes.find(
      (feature) => feature.id === Features.payroll_management
    )?.available ?? false
  const jobCatalogContextlessPolicies = data?.jobCatalog?._policies
  const contractVersions = data?.contracts.contractVersionsConnection.nodes ?? []

  return (
    <ResponsivePage.Body
      variant="fullscreen"
      loading={loading}
      error={!referenceContract}
      authorized={!!referenceContract && canAccessFlowsPage}
    >
      {!!referenceContract && hasToRequestPromotion && (
        <RequestPromoteFlow
          contractVersion={referenceContract}
          jobCatalogTrees={jobCatalogTrees}
          jobCatalogTreeFeatureEnabled={jobCatalogTreeFeatureEnabled}
          jobCatalogContextlessPolicies={jobCatalogContextlessPolicies}
          hasPayrollBundle={hasPayrollBundle}
          contractVersions={contractVersions}
        />
      )}
      {!!referenceContract && !hasToRequestPromotion && (
        <PromoteFlow
          contractVersion={referenceContract}
          jobCatalogTrees={jobCatalogTrees}
          jobCatalogTreeFeatureEnabled={jobCatalogTreeFeatureEnabled}
          jobCatalogContextlessPolicies={jobCatalogContextlessPolicies}
          hasPayrollBundle={hasPayrollBundle}
          contractVersions={contractVersions}
        />
      )}
    </ResponsivePage.Body>
  )
}

export default RequestOrPromote
